<template>
    <v-container style="height: 100vh;">
        <div v-if="!event_started" class="outer-container">
            <div class="inner-container">
                <h1>{{ event_name }}</h1>
                <div class="countdown my-3">
                    <div class="d-flex align-center justify-center">
                        <div class="day mx-2">
                            <span class="number">{{ timesLeft.days }}</span>
                            <div class="format text-center">วัน</div>
                        </div>
                        <div class="hour mx-2">
                            <span class="number">{{ timesLeft.hours }}</span>
                            <div class="format text-center">ชั่วโมง</div>
                        </div>
                        <div class="min mx-2">
                            <span class="number">{{ timesLeft.minutes }}</span>
                            <div class="format text-center">นาที</div>
                        </div>
                        <div class="sec mx-2">
                            <span class="number">{{ timesLeft.seconds }}</span>
                            <div class="format text-center">วินาที</div>
                        </div>
                    </div>
                    <div class="d-flex flex-column my-5">
                        <div class="mx-3 text-sm-center"><h3>อีเวนท์นี้จะเริ่มในวันที่</h3></div>
                        <div class="mx-3 text-center">{{ event_begin }}</div>
                    </div>
                </div>

              </div>
        </div>
        <div v-else class="text-center">
            <h4 class="text-lpn my-10">
                <v-progress-circular
                        indeterminate
                        size="20"
                        color="blue"
                ></v-progress-circular>
                Loading event ... please wait</h4>
        </div>
    </v-container>
</template>

<script>
    export default {
        name: "CountdownEvent",
        props: {
            event_start:{type: String, default: ''},
            event_end:{type: String, default: ''},
            redirect_route:{type: Object, default: null},
            event_name:{type: String, default: 'เปิดจองออนไลน์ในอีก...'},
        },
        data() {
            return {
                intervalTimer:0,
                timeLeft: '00:00:00:00',
                event_begin: null,
                event_started:true,
                timesLeft:{
                    days:'00',
                    hours:'00',
                    minutes:'00',
                    seconds:'00',
                }
            }
        },
        created(){
            this.setTime(this.serverDiffTime())
            this.moment.locale('th')
            this.event_begin = this.moment(this.event_start, 'YYYY-MM-DD H:m:s.z').format('DD/MM/YYYY เวลา H:m:s')
        },
        methods: {
            serverDiffTime(){
                //TODO ต้องดึงเวลาปัจจุบันจาก server
                const current_server_datetime = this.moment().format('YYYY-MM-DD H:m:s.z')//'2020-12-29 12:35:42.507'
                // const current_server_datetime = '2021-03-01 12:35:42.507'

                const start_date = this.moment(this.event_start, 'YYYY-MM-DD H:m:s.z')
                const current_date = this.moment(current_server_datetime, 'YYYY-MM-DD H:m:s.z')
                let remain_sec = start_date.diff(current_date, 'second')

                if(current_date>start_date){
                    remain_sec = 0
                }

                return remain_sec
            },
            setTime(seconds) {
                clearInterval(this.intervalTimer)
                this.timer(seconds)
            },
            timer(seconds) {
                const now = Date.now()
                const end = now + seconds * 1000
                // this.displayTimeLeft(seconds)

                this.countdown(end)
            },
            countdown(end) {
                this.intervalTimer = setInterval(() => {
                    const secondsLeft = Math.round((end - Date.now()) / 1000)

                    if(secondsLeft < 0) {
                        clearInterval(this.intervalTimer)
                        this.event_started = true
                        console.log('Event start')
                        this.$parent.setEventStart()
                        return;
                    }else{
                        this.event_started = false
                    }

                    this.displayTimeLeft(secondsLeft)
                }, 1000)
            },
            displayTimeLeft(secondsLeft) {
                const days        = Math.floor(secondsLeft/24/60/60)
                const hoursLeft   = Math.floor((secondsLeft) - (days*86400))
                const hours       = Math.floor(hoursLeft/3600)
                const minutesLeft = Math.floor((hoursLeft) - (hours*3600))
                const minutes     = Math.floor(minutesLeft/60)
                const seconds = secondsLeft % 60

                this.timesLeft.days = this.zeroPadded(days)
                this.timesLeft.hours = this.zeroPadded(hours)
                this.timesLeft.minutes = this.zeroPadded(minutes)
                this.timesLeft.seconds = this.zeroPadded(seconds)
            },
            zeroPadded(num) {
                // 4 --> 04
                return num < 10 ? `0${num}` : num
            },
            hourConvert(hour) {
                // 15 --> 3
                return (hour % 12) || 12
            }
        }
    }
</script>

<style scoped>
    /* ==================
     *  BASE
     * ================== */
    body {
        font-family: 'Sarpanch', sans-serif;
        color: hsl(0, 0%, 7%);
        background: #f2f1ed;
        background: radial-gradient(hsl(204, 86%, 93%), hsl(204, 86%, 63%));
    }
    .outer-container {
        display: flex;
        align-items: center;
        flex-direction: column;
        height: 90vh;
        justify-content: center;
    }
    /* ==================
     *  APP
     * ================== */
    .countdown {
        margin: 5px 0 30px;
    }
    h1 {
        text-align: center;
        font-size: 28px;
        color: hsl(204, 86%, 43%);
    }
    h2 {
        font-size: 120px;
        width: 390px;
        line-height: 1;
        text-align: center;
    }
    h3 {
        font-size: 18px;
        display: flex;
        align-items: baseline;
        justify-content: center;
    }
    h3 span {
        width: 70px;
        border-bottom: 2px solid hsl(348, 100%, 71%);
        margin-left: 15px;
        text-align: center;
    }
    .time {
        display: flex;
        justify-content: center;
    }
    .columns {
        margin-left: 0;
        margin-right: 0;
    }

    .format {
        font-weight: 300;
        font-size: 14px;
        opacity: 0.8;
        width: 60px;
    }

    .number{
        font-size: 2.5rem;
        /*background: rgba(51, 51, 51, 0.53);*/
        background: #16448f;
        color:#fff;
        padding: 0 5px;
        border-radius: 5px;
        display: inline-block;
        min-width: 65px;
        text-align: center;
    }
</style>
